export interface YearlyPerformance {
  year: number;
  equity: number;
  bonds: number;
}

// Approximate annual total returns (including dividends/coupons).
// Equity: S&P 500 Total Return proxy. Bonds: US Aggregate Bond proxy.
// Values are rounded to two decimals; the series is illustrative, not tick-exact.
const EQUITY_RETURNS: Record<number, number> = {
  1976: 0.238, 1977: -0.072, 1978: 0.066, 1979: 0.184, 1980: 0.324,
  1981: -0.049, 1982: 0.216, 1983: 0.226, 1984: 0.063, 1985: 0.322,
  1986: 0.186, 1987: 0.052, 1988: 0.166, 1989: 0.315, 1990: -0.031,
  1991: 0.305, 1992: 0.076, 1993: 0.101, 1994: 0.013, 1995: 0.376,
  1996: 0.230, 1997: 0.334, 1998: 0.286, 1999: 0.210, 2000: -0.091,
  2001: -0.119, 2002: -0.221, 2003: 0.287, 2004: 0.109, 2005: 0.049,
  2006: 0.158, 2007: 0.055, 2008: -0.370, 2009: 0.265, 2010: 0.151,
  2011: 0.021, 2012: 0.160, 2013: 0.324, 2014: 0.137, 2015: 0.014,
  2016: 0.120, 2017: 0.218, 2018: -0.044, 2019: 0.315, 2020: 0.184,
  2021: 0.287, 2022: -0.181, 2023: 0.263, 2024: 0.250, 2025: 0.120,
};

const BOND_RETURNS: Record<number, number> = {
  1976: 0.156, 1977: 0.030, 1978: 0.014, 1979: 0.019, 1980: 0.027,
  1981: 0.063, 1982: 0.326, 1983: 0.084, 1984: 0.152, 1985: 0.221,
  1986: 0.153, 1987: 0.028, 1988: 0.079, 1989: 0.145, 1990: 0.090,
  1991: 0.160, 1992: 0.074, 1993: 0.098, 1994: -0.029, 1995: 0.185,
  1996: 0.036, 1997: 0.097, 1998: 0.087, 1999: -0.008, 2000: 0.116,
  2001: 0.084, 2002: 0.103, 2003: 0.041, 2004: 0.043, 2005: 0.024,
  2006: 0.043, 2007: 0.070, 2008: 0.052, 2009: 0.059, 2010: 0.065,
  2011: 0.078, 2012: 0.042, 2013: -0.020, 2014: 0.060, 2015: 0.005,
  2016: 0.026, 2017: 0.035, 2018: 0.000, 2019: 0.087, 2020: 0.075,
  2021: -0.015, 2022: -0.130, 2023: 0.055, 2024: 0.013, 2025: 0.045,
};

function buildSeries(): YearlyPerformance[] {
  const startYear = 1975;
  const endYear = 2025;
  const series: YearlyPerformance[] = [{ year: startYear, equity: 100, bonds: 100 }];
  let equity = 100;
  let bonds = 100;
  for (let y = startYear + 1; y <= endYear; y++) {
    equity *= 1 + (EQUITY_RETURNS[y] ?? 0);
    bonds *= 1 + (BOND_RETURNS[y] ?? 0);
    series.push({
      year: y,
      equity: Math.round(equity * 100) / 100,
      bonds: Math.round(bonds * 100) / 100,
    });
  }
  return series;
}

export const HISTORICAL_PERFORMANCE: YearlyPerformance[] = buildSeries();
